module.exports = __webpack_public_path__ + "static/img/carousel-3.b136cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/carousel-3.png
// module id = dX6S
// module chunks = 15